<template>
  <div class="home">
    <h1>Welcome to Vision Cloud</h1>
    <div class="dashboard-grid">
      <div class="dashboard-card" @click="$router.push('/line-items')">
        <h2>Line Items</h2>
        <p>Manage and search line items</p>
      </div>
      <div class="dashboard-card" @click="$router.push('/kits')">
        <h2>Kits</h2>
        <p>View and manage kits</p>
      </div>
      <div class="dashboard-card" @click="$router.push('/jobs')">
        <h2>Jobs</h2>
        <p>Track and manage jobs</p>
      </div>
      <div class="dashboard-card" @click="$router.push('/completed-work')">
        <h2>Completed Work</h2>
        <p>View completed work records</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home {
  padding: 2rem;
}

h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.dashboard-card {
  background: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.dashboard-card h2 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.dashboard-card p {
  color: #666;
}
</style>
